import React from "react";
import AboutMe from "../components/about/index";
import Wrapper from "../components/wrapper/index";

function About() {
  return (
    <Wrapper>
      <AboutMe />
    </Wrapper>
  );
}

export default About;